// extracted by css-extract-rspack-plugin
export default {"info":"GE2Cb","icon":"ubdek"};